module.exports = __webpack_public_path__ + "static/img/p001.7353aa7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/p001.png
// module id = cu5Y
// module chunks = 0